module.exports = __webpack_public_path__ + "static/media/icon-internet-test.955ec70a.svg";